import { YeuCauDuyetGiaChiTiet } from "./../../yeu-cau-duyet-gia/yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model";
import { BaseModel } from "../../../../../../core/_base/crud";
import { cssToStr } from "@fullcalendar/core";
import { ReplaySubject } from "rxjs";
import { FileImport } from "../../../dung-chung/__model/file-import.model";
import { title } from "process";

export class DSYeuCauDuyetGia extends BaseModel {
	IdDG: number;
	IdDGCT: number;
	SoPhieu: string;
	MaKH: string;
	TenKH: string;
	MaHH: string;
	TenHH: string;
	SoLuong: number;
	TenDVT: string;
	GiaKhachHangMongMuon: number;
	GiaDeNghiBan: number;
	ThoiGianGiuGia: number;
	NgayLapPhieu: Date;
	TrangThai_Code: string;

	clear() {
		this.IdDG = 0;
		this.IdDGCT = 0;
		this.SoPhieu = "";
		this.MaKH = "";
		this.TenKH = "";
		this.MaHH = "";
		this.TenHH = "";
		this.SoLuong = 0;
		this.TenDVT = "";
		this.GiaKhachHangMongMuon = 0;
		this.GiaDeNghiBan = 0;
		this.ThoiGianGiuGia = 0;
		this.NgayLapPhieu = null;
		this.TrangThai_Code = "";
	}

	copy(item: DSYeuCauDuyetGia) {
		this.IdDG = item.IdDG;
		this.IdDGCT = item.IdDGCT;
		this.SoPhieu = item.SoPhieu;
		this.MaKH = item.MaKH;
		this.TenKH = item.TenKH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.SoLuong = item.SoLuong;
		this.TenDVT = item.TenDVT;
		this.GiaKhachHangMongMuon = item.GiaKhachHangMongMuon;
		this.GiaDeNghiBan = item.GiaDeNghiBan;
		this.ThoiGianGiuGia = item.ThoiGianGiuGia;
		this.NgayLapPhieu = item.NgayLapPhieu;
		this.TrangThai_Code = item.TrangThai_Code;
	}
}

export class ListLSBan extends BaseModel {
	Id: number;
	SoPhieu: string;
	MaHang: string;
	TenHang: string;
	SoLuong: number;
	DVT: string;
	GiaBan: number;
	NgayLap: Date;
}

export class KDDatHang extends BaseModel {
	IdDH: number;
	SoPhieu: string;
	NgayLapPhieu: string;
	NguoiLapPhieu: number;
	TenNguoiLapPhieu: string;
	TrangThai_Code: string;
	TrangThai_Desc: string;
	Type: number;
	PhieuYCDG: string;
	GhiChu: string;
	IdKH: number;
	MaKH: string;
	TenKH: string;
	TongTienChuaThue: number;
	ThueGTGT: number;
	TongTien: number;
	TPDuyet_Id: number;
	TPDuyet_Ten: string;
	TPDuyet_NgayDuyet: string;
	TPDuyet_LyDo: string;
	KHDuyet_Id: number;
	KHDuyet_Ten: string;
	KHDuyet_NgayDuyet: string;
	KHDuyet_LyDo: string;
	NguoiChotDon_Id: number;
	NguoiChotDon_Ten: string;
	NguoiChotDon_NgayDuyet: string;
	NguoiChotDon_LyDo: string;
	SoPhieuYCDG: string;
	DongDon_LyDo: string;
	Cts: KDDatHangChiTiet[];
	LoaiPhieu: number;
	PriceEvidenceFiles: any[];
	CustomerPurchaseOrder: string;
	IsChangeCustomerPurchaseOrder: boolean;
	BusinessModel: string;
	IsCloseForecast: boolean;
	CanCancel: boolean;
	CanConfirm: boolean;
	ViewHistoriesForecastChange: boolean;
	LoaiChietKhau: string;
	TenLoaiChietKhau: string;
	GiaTriChietKhau: number;
	CanCreate: boolean;
	CanClose: boolean;
	ChannelOrPlatform: string;
	PlanEmployeeConfirmDate: string;
	PlanEmployeeConfirmName: string;
	PlanEmployeeConfirmReason: string;
	IsHistoriesChangeForecast: boolean;
	CustomerTypeId: number;
	TempCustomerType: string;
	clear() {
		this.IdDH = 0;
		this.SoPhieu = "";
		this.NgayLapPhieu = "";
		this.NguoiLapPhieu = 0;
		this.TenNguoiLapPhieu = "";
		this.TrangThai_Code = "";
		this.TrangThai_Desc = "";
		this.Type = 0;
		this.PhieuYCDG = "";
		this.IdKH = 0;
		this.MaKH = "";
		this.TenKH = "";
		this.TongTienChuaThue = 0;
		this.ThueGTGT = 0;
		this.TongTien = 0;
		this.TPDuyet_Id = 0;
		this.TPDuyet_Ten = "";
		this.TPDuyet_NgayDuyet = "";
		this.TPDuyet_LyDo = "";
		this.KHDuyet_Id = 0;
		this.KHDuyet_Ten = "";
		this.KHDuyet_NgayDuyet = "";
		this.KHDuyet_LyDo = "";
		this.NguoiChotDon_Id = 0;
		this.NguoiChotDon_Ten = "";
		this.NguoiChotDon_NgayDuyet = "";
		this.NguoiChotDon_LyDo = "";
		this.GhiChu = "";
		this.DongDon_LyDo = "";
		this.Cts = [];
		this.SoPhieuYCDG = "";
		this.LoaiPhieu = 1;
		this.PriceEvidenceFiles = [];
		this.CustomerPurchaseOrder = "";
		this.IsChangeCustomerPurchaseOrder = false;
		this.BusinessModel = ConstantPurchaseOrder.CODE_B2B;
		this.IsCloseForecast = false;
		this.CanCancel = false;
		this.CanConfirm = false;
		this.ViewHistoriesForecastChange = false;
		this.LoaiChietKhau = ConstantPurchaseOrder.DROPDOWN_LOAICHIETKHAU.find((o) => o.default).key;
		this.TenLoaiChietKhau = ConstantPurchaseOrder.DROPDOWN_LOAICHIETKHAU.find((o) => o.default).value;
		this.GiaTriChietKhau = 0;
		this.CanCreate = false;
		this.CanClose = false;
		this.ChannelOrPlatform = "";
		this.PlanEmployeeConfirmDate = "";
		this.PlanEmployeeConfirmName = "";
		this.PlanEmployeeConfirmReason = "";
		this.IsHistoriesChangeForecast = false;
		this.CustomerTypeId = null;
		this.TempCustomerType = "";
	}
	copy(item: KDDatHang) {
		this.IdDH = item.IdDH;
		this.SoPhieu = item.SoPhieu;
		this.NgayLapPhieu = item.NgayLapPhieu;
		this.NguoiLapPhieu = item.NguoiLapPhieu;
		this.TenNguoiLapPhieu = item.TenNguoiLapPhieu;
		this.TrangThai_Code = item.TrangThai_Code;
		this.TrangThai_Desc = item.TrangThai_Desc;
		this.Type = item.Type;
		this.PhieuYCDG = item.PhieuYCDG;
		this.IdKH = item.IdKH;
		this.MaKH = item.MaKH;
		this.TenKH = item.TenKH;
		this.TongTienChuaThue = item.TongTienChuaThue;
		this.ThueGTGT = item.ThueGTGT;
		this.TongTien = item.TongTien;
		this.TPDuyet_Id = item.TPDuyet_Id;
		this.TPDuyet_Ten = item.TPDuyet_Ten;
		this.TPDuyet_NgayDuyet = item.TPDuyet_NgayDuyet;
		this.TPDuyet_LyDo = item.TPDuyet_LyDo;
		this.KHDuyet_Id = item.KHDuyet_Id;
		this.KHDuyet_Ten = item.KHDuyet_Ten;
		this.KHDuyet_NgayDuyet = item.KHDuyet_NgayDuyet;
		this.KHDuyet_LyDo = item.KHDuyet_LyDo;
		this.NguoiChotDon_Id = item.NguoiChotDon_Id;
		this.NguoiChotDon_Ten = item.NguoiChotDon_Ten;
		this.NguoiChotDon_NgayDuyet = item.NguoiChotDon_NgayDuyet;
		this.NguoiChotDon_LyDo = item.NguoiChotDon_LyDo;
		this.Cts = item.Cts;
		this.SoPhieuYCDG = item.SoPhieuYCDG;
		this.LoaiPhieu = item.LoaiPhieu;
		this.GhiChu = item.GhiChu;
		this.DongDon_LyDo = item.DongDon_LyDo;
		this.PriceEvidenceFiles = item.PriceEvidenceFiles;
		this.CustomerPurchaseOrder = item.CustomerPurchaseOrder;
		this.IsChangeCustomerPurchaseOrder = item.IsChangeCustomerPurchaseOrder;
		this.BusinessModel = item.BusinessModel;
		this.IsCloseForecast = item.IsCloseForecast;
		this.CanCancel = item.CanCancel;
		this.CanConfirm = item.CanConfirm;
		this.ViewHistoriesForecastChange = item.ViewHistoriesForecastChange;
		this.LoaiChietKhau = item.LoaiChietKhau;
		this.TenLoaiChietKhau = item.TenLoaiChietKhau;
		this.GiaTriChietKhau = item.GiaTriChietKhau;
		this.CanCreate = item.CanCreate;
		this.CanClose = item.CanClose;
		this.ChannelOrPlatform = item.ChannelOrPlatform;
		this.PlanEmployeeConfirmDate = item.PlanEmployeeConfirmDate;
		this.PlanEmployeeConfirmName = item.PlanEmployeeConfirmName;
		this.PlanEmployeeConfirmReason = item.PlanEmployeeConfirmReason;
		this.IsHistoriesChangeForecast = item.IsHistoriesChangeForecast;
		this.CustomerTypeId = item.CustomerTypeId;
		this.TempCustomerType = item.TempCustomerType;
	}
}

export class KDDatHangLs extends BaseModel {
	TenNguoiDuyet: string;
	GhiChu: string;
	ThaoTac: string;
}

export class ThongTinXacNhanModel extends BaseModel {
	Id: number;
	IdCt: number;
	SoPhieu: string;
	IdDH: number;
	IdHH: number;
	MaHH: string;
	TenHH: string;
	NgayXacNhan: string;
	NguoiXacNhan: number;
	TenNguoiXacNhan: string;
	SLDat: number;
	NgayYCGH: string;
	TrangThai: string;
	CTs: ThongTinXacNhanCTModel[];
	Histories: ThongTinXacNhanCTModel[];
	clear() {
		this.Id = 0;
		this.IdCt = 0;
		this.SoPhieu = "";
		this.IdDH = 0;
		this.IdHH = 0;
		this.MaHH = "";
		this.TenHH = "";
		this.NgayXacNhan = "";
		this.NguoiXacNhan = 0;
		this.TenNguoiXacNhan = "";
		this.SLDat = 0;
		this.NgayYCGH = "";
		this.TrangThai = "";
		this.CTs = [];
		this.Histories = [];
	}
}

export class ThongTinXacNhanCTModel extends BaseModel {
	Id: number;
	IdCt: number;
	IdDH: number;
	SLGiao: number;
	NgayGiao: string;
	NgayYCGiao: string;
	NgayYCGiaoMoi: string;
	TrangThai: string;
	IdParent: number;
	clear() {
		this.Id = 0;
		this.IdCt = 0;
		this.IdDH = 0;
		this.SLGiao = 0;
		this.NgayGiao = "";
		this.NgayYCGiao = "";
		this.NgayYCGiaoMoi = "";
		this.TrangThai = "";
		this.IdParent = 0;
	}
}

export class KDDatHangChiTiet extends BaseModel {
	IdYCDG: number;
	SoPhieuYCDG: string;
	IdCt: number;
	IdDH: number;
	IdHH: number;
	MaHH: string;
	TenHH: string;
	QuyCach: string;
	DVT: number;
	TenDVT: string;
	NgayGiaoHang: string;
	NgayGiaoHangTu: string;
	NgayGiaoHangDen: string;
	KhoiLuong: number;
	TienTe_Id: number;
	TienTe_Ten: string;
	DonGia: number;
	ThanhTien: number;
	ThanhTienQuyDoi: number;
	GhiChu: string;
	ThuocForecast: boolean;
	YeuCauDuyetGiaCt: number;
	TyGia: number;
	isDongYYCGH: boolean;
	isHoanTatKHGHMoi: boolean;
	PhanTramThueVAT: number;
	TienThueVAT: number;
	SoLuongDaGiao: number;
	TonKho: number;
	ListDetailGiaoHang: DetailGiaoHang[];
	isExpanded: boolean;
	TrangThai_Desc: string;
	TrangThai_Code: string;
	Forecast_Id: number;
	Forecast_SoPhieu: string;
	ListForecast: any[];
	filteredListForecast: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ForecastFilterCtrl: string;
	oldKhoiLuong: number;
	SLCoPO: number;
	SLTuDo: number;
	DiaChiGiaoHang: string;
	CanConfirmDetails: boolean;
	CanChangeForecast: boolean;
	CanDuplicate: boolean;
	CanForecastChange: boolean;
	CanAccept: boolean;
	POOfCustomer: string;
	QuantityToBeConfirmed: number;
	HasBeenChanged: boolean;
	LatestQuantityInHistory: number;
	ForecastDetailId: number;
	BranchId: number;
	CanUpdateForForecast: boolean;
	clear() {
		this.IdYCDG = 0;
		this.SoPhieuYCDG = "";
		this.IdCt = 0;
		this.IdDH = 0;
		this.IdHH = 0;
		this.MaHH = "";
		this.TenHH = "";
		this.QuyCach = "";
		this.DVT = 0;
		this.TenDVT = "";
		this.NgayGiaoHang = "";
		this.NgayGiaoHangTu = "";
		this.NgayGiaoHangDen = "";
		this.KhoiLuong = 0;
		this.TienTe_Id = 0;
		this.TienTe_Ten = "";
		this.DonGia = 0;
		this.ThanhTien = 0;
		this.ThanhTienQuyDoi = 0;
		this.GhiChu = "";
		this.ThuocForecast = false;
		this.YeuCauDuyetGiaCt = 0;
		this.TyGia = 0;
		this.isDongYYCGH = false;
		this.isHoanTatKHGHMoi = false;
		this.PhanTramThueVAT = 0;
		this.TienThueVAT = 0;
		this.SoLuongDaGiao = 0;
		this.TonKho = 0;
		this.ListDetailGiaoHang = [];
		this.isExpanded = false;
		this.TrangThai_Desc = "";
		this.TrangThai_Code = "";
		this.Forecast_Id = 0;
		this.Forecast_SoPhieu = "";
		this.ListForecast = [];
		this.ForecastFilterCtrl = "";
		this.oldKhoiLuong = this.KhoiLuong;
		this.SLCoPO = 0;
		this.SLTuDo = 0;
		this.DiaChiGiaoHang = "";
		this.CanConfirmDetails = false;
		this.CanChangeForecast = false;
		this.CanDuplicate = false;
		this.CanForecastChange = false;
		this.CanAccept = false;
		this.POOfCustomer = "";
		this.filteredListForecast.next([]);
		this.QuantityToBeConfirmed = null;
		this.HasBeenChanged = false;
		this.LatestQuantityInHistory = null;
		this.ForecastDetailId = null;
		this.BranchId = null;
		this.CanUpdateForForecast = false;
	}
	copy(item: KDDatHangChiTiet) {
		this.IdYCDG = item.IdYCDG;
		this.SoPhieuYCDG = item.SoPhieuYCDG;
		this.IdCt = item.IdCt;
		this.IdDH = item.IdDH;
		this.IdHH = item.IdHH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.QuyCach = item.QuyCach;
		this.DVT = item.DVT;
		this.TenDVT = item.TenDVT;
		this.NgayGiaoHang = item.NgayGiaoHang;
		this.NgayGiaoHangTu = item.NgayGiaoHangTu;
		this.NgayGiaoHangDen = item.NgayGiaoHangDen;
		this.KhoiLuong = item.KhoiLuong;
		this.TienTe_Id = item.TienTe_Id;
		this.TienTe_Ten = item.TienTe_Ten;
		this.DonGia = item.DonGia;
		this.ThanhTien = item.ThanhTien;
		this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
		this.GhiChu = item.GhiChu;
		this.ThuocForecast = item.ThuocForecast;
		this.YeuCauDuyetGiaCt = item.YeuCauDuyetGiaCt;
		this.TyGia = item.TyGia;
		this.isDongYYCGH = item.isDongYYCGH;
		this.isHoanTatKHGHMoi = item.isHoanTatKHGHMoi;
		this.PhanTramThueVAT = item.PhanTramThueVAT;
		this.TienThueVAT = item.TienThueVAT;
		this.SoLuongDaGiao = item.SoLuongDaGiao;
		this.TonKho = item.TonKho;
		this.ListDetailGiaoHang = item.ListDetailGiaoHang;
		this.isExpanded = item.isExpanded;
		this.TrangThai_Desc = item.TrangThai_Desc;
		this.TrangThai_Code = item.TrangThai_Code;
		this.Forecast_Id = item.Forecast_Id;
		this.Forecast_SoPhieu = item.Forecast_SoPhieu;
		this.ListForecast = item.ListForecast;
		this.oldKhoiLuong = item.KhoiLuong;
		this.SLCoPO = item.SLCoPO;
		this.SLTuDo = item.SLTuDo;
		this.DiaChiGiaoHang = item.DiaChiGiaoHang;
		this.CanConfirmDetails = item.CanConfirmDetails;
		this.CanChangeForecast = item.CanChangeForecast;
		this.CanDuplicate = item.CanDuplicate;
		this.CanForecastChange = item.CanForecastChange;
		this.CanAccept = item.CanAccept;
		this.POOfCustomer = item.POOfCustomer;
		this.filteredListForecast.next([]);
		this.QuantityToBeConfirmed = item.QuantityToBeConfirmed;
		this.HasBeenChanged = item.HasBeenChanged;
		this.LatestQuantityInHistory = item.LatestQuantityInHistory;
		this.ForecastDetailId = item.ForecastDetailId;
		this.BranchId = item.BranchId;
		this.CanUpdateForForecast = item.CanUpdateForForecast;
	}
}

export class DetailGiaoHang extends BaseModel {
	IdYCDG: number;
	SoPhieuYCDG: string;
	IdCt: number;
	IdDH: number;
	IdHH: number;
	MaHH: string;
	TenHH: string;
	QuyCach: string;
	DVT: number;
	TenDVT: string;
	NgayGiaoHang: string;
	NgayGiaoHangTu: string;
	NgayGiaoHangDen: string;
	KhoiLuong: number;
	TienTe_Id: number;
	TienTe_Ten: string;
	DonGia: number;
	ThanhTien: number;
	ThanhTienQuyDoi: number;
	GhiChu: string;
	ThuocForecast: boolean;
	YeuCauDuyetGiaCt: number;
	TyGia: number;
	isDongYYCGH: boolean;
	isHoanTatKHGHMoi: boolean;
	PhanTramThueVAT: number;
	TienThueVAT: number;
	SoLuongDaGiao: number;
	TonKho: number;
	TrangThai_Desc: string;
	TrangThai_Code: string;
	DiaChiGiaoHang: string;
	ForecastDetailId: number;
	BranchId: number;
	clear() {
		this.IdYCDG = 0;
		this.SoPhieuYCDG = "";
		this.IdCt = 0;
		this.IdDH = 0;
		this.IdHH = 0;
		this.MaHH = "";
		this.TenHH = "";
		this.QuyCach = "";
		this.DVT = 0;
		this.TenDVT = "";
		this.NgayGiaoHang = "";
		this.NgayGiaoHangTu = "";
		this.NgayGiaoHangDen = "";
		this.KhoiLuong = 0;
		this.TienTe_Id = 0;
		this.TienTe_Ten = "";
		this.DonGia = 0;
		this.ThanhTien = 0;
		this.ThanhTienQuyDoi = 0;
		this.GhiChu = "";
		this.ThuocForecast = false;
		this.YeuCauDuyetGiaCt = 0;
		this.TyGia = 0;
		this.isDongYYCGH = false;
		this.isHoanTatKHGHMoi = false;
		this.PhanTramThueVAT = 0;
		this.TienThueVAT = 0;
		this.SoLuongDaGiao = 0;
		this.TonKho = 0;
		this.TrangThai_Desc = "";
		this.TrangThai_Code = "";
		this.DiaChiGiaoHang = "";
		this.ForecastDetailId = null;
		this.BranchId = null;
	}
	copy(item: KDDatHangChiTiet) {
		this.IdYCDG = item.IdYCDG;
		this.SoPhieuYCDG = item.SoPhieuYCDG;
		this.IdCt = item.IdCt;
		this.IdDH = item.IdDH;
		this.IdHH = item.IdHH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.QuyCach = item.QuyCach;
		this.DVT = item.DVT;
		this.TenDVT = item.TenDVT;
		this.NgayGiaoHang = item.NgayGiaoHang;
		this.NgayGiaoHangTu = item.NgayGiaoHangTu;
		this.NgayGiaoHangDen = item.NgayGiaoHangDen;
		this.KhoiLuong = item.KhoiLuong;
		this.TienTe_Id = item.TienTe_Id;
		this.TienTe_Ten = item.TienTe_Ten;
		this.DonGia = item.DonGia;
		this.ThanhTien = item.ThanhTien;
		this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
		this.GhiChu = item.GhiChu;
		this.ThuocForecast = item.ThuocForecast;
		this.YeuCauDuyetGiaCt = item.YeuCauDuyetGiaCt;
		this.TyGia = item.TyGia;
		this.isDongYYCGH = item.isDongYYCGH;
		this.isHoanTatKHGHMoi = item.isHoanTatKHGHMoi;
		this.PhanTramThueVAT = item.PhanTramThueVAT;
		this.TienThueVAT = item.TienThueVAT;
		this.SoLuongDaGiao = item.SoLuongDaGiao;
		this.TonKho = item.TonKho;
		this.TrangThai_Desc = item.TrangThai_Desc;
		this.TrangThai_Code = item.TrangThai_Code;
		this.DiaChiGiaoHang = item.DiaChiGiaoHang;
		this.ForecastDetailId = item.ForecastDetailId;
		this.BranchId = item.BranchId;
	}
}

export class KDDatHangDeNghi extends BaseModel {
	IdHH = 0;
	MaHH = "";
	TenHH = "";
	QuyCach = "";
	IdDVT = 0;
	TenDVT = "";
	SoLuong = 0;
	IdDNMH = 0;
	SoPhieuDNMH = "";
	IdNCC = 0;
	MaNCC = "";
	TenNCC = "";
	NgayLap = "";
	NguoiLap = 0;
	TenNguoiLap = "";
	IdPBDN = 0;
	TenPBDN = "";
	TrangThai = 0;
	NgayGiaoDuKien = "";
	GhiChu = "";
	DonGia = 0;
	ThanhTien = 0;
	Code = "";

	clear() {
		this.IdHH = 0;
		this.MaHH = "";
		this.TenHH = "";
		this.QuyCach = "";
		this.IdDVT = 0;
		this.TenDVT = "";
		this.SoLuong = 0;
		this.IdDNMH = 0;
		this.SoPhieuDNMH = "";
		this.IdNCC = 0;
		this.TenNCC = "";
		this.MaNCC = "";
		this.NgayLap = "";
		this.NguoiLap = 0;
		this.TenNguoiLap = "";
		this.IdPBDN = 0;
		this.TenPBDN = "";
		this.TrangThai = 0;
		this.NgayGiaoDuKien = "";
		this.GhiChu = "";
		this.DonGia = 0;
		this.ThanhTien = 0;
		this.Code = "";
	}
	copy(item: KDDatHangDeNghi) {
		this.IdHH = item.IdHH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.QuyCach = item.QuyCach;
		this.IdDVT = item.IdDVT;
		this.TenDVT = item.TenDVT;
		this.SoLuong = item.SoLuong;
		this.IdDNMH = item.IdDNMH;
		this.SoPhieuDNMH = item.SoPhieuDNMH;
		this.IdNCC = item.IdNCC;
		this.TenNCC = item.TenNCC;
		this.MaNCC = item.MaNCC;
		this.NgayLap = item.NgayLap;
		this.NguoiLap = item.NguoiLap;
		this.TenNguoiLap = item.TenNguoiLap;
		this.IdPBDN = item.IdPBDN;
		this.TenPBDN = item.TenPBDN;
		this.TrangThai = item.TrangThai;
		this.NgayGiaoDuKien = item.NgayGiaoDuKien;
		this.GhiChu = item.GhiChu;
		this.DonGia = item.DonGia;
		this.ThanhTien = item.ThanhTien;
		this.Code = item.Code;
	}
}

export class HistoriesForecastChangeBody extends BaseModel {
	Mahh: string;
	Tenhh: string;
	SoLuongGoc: number;
	SoLuongThayDoi: number;
	TenNguoiYeuCau: string;
	TenDvt: string;
	ThoiGianYeuCau: string;
	ThaoTac: string;
}

export class HistoriesForecastChangeParam extends BaseModel {
	DatHangId: number;
	Details: HistoriesForecastChangeDetailParam[];
}

export class HistoriesForecastChangeDetailParam extends BaseModel {
	DatHangCtId: number;
	SoLuongThayDoi: number;
	GhiChu: string;
}

export class DongYYCXNModel extends BaseModel {
	IdDH: number;
	IdCt: number;
}

export class DeXuatKHGHMoiNModel extends BaseModel {
	IdDH: number;
	IdCt: number;
}

export class POColumns {
	static columns = [
		{
			stt: 0,
			name: "select",
			displayName: "select",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 2,
			name: "SLGIAO",
			displayName: "Số lượng giao",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "NGAYGIAO",
			displayName: "Ngày giao",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "NGAYGIAOMOI",
			displayName: "Ngày giao mới",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "DETACHED",
			displayName: "Tách",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "USERGIAOMOI",
			displayName: "Người đề xuất",
			alwaysChecked: false,
			isShow: true,
		},
	];
}

export class ConstantPurchaseOrder {
	public static readonly OPTION_PURCHASEORDER = "0";
	public static readonly OPTION_FORECAST = "1";
	public static readonly ACTION_DONGYYCGH = "KDDH_DONGYYCGH";
	public static readonly PARAM_FORECAST_B2B = "forecast-b2b";
	public static readonly PARAM_FORECAST_B2C = "forecast-b2c";
	public static readonly PARAM_PURCHASE_ORDER_B2B = "don-hang-ban-b2b";
	public static readonly PARAM_PURCHASE_ORDER_B2C = "don-hang-ban-b2c";
	public static readonly PARAM_SCHEDULE_B2B = "lich-xuat-hang-ban-b2b";
	public static readonly PARAM_SCHEDULE_B2C = "lich-xuat-hang-ban-b2c";
	public static readonly TITLE_FORECAST_B2B = "Danh sách forecast B2B";
	public static readonly TITLE_FORECAST_B2C = "Danh sách forecast B2C";
	public static readonly TITLE_PURCHASE_ORDER_B2B = "Danh sách đơn hàng bán B2B";
	public static readonly TITLE_PURCHASE_ORDER_B2C = "Danh sách đơn hàng bán B2C";
	public static readonly CODE_B2B = "B2B";
	public static readonly CODE_B2C = "B2C";
	public static readonly API_PO_B2B = "-pob2b";
	public static readonly API_PO_B2C = "-pob2c";
	public static readonly API_FORECAST = "-forecast";
	public static readonly STATUS_FORECAST_B2B = [
		{
			value: "KDDH_DANGSOANTHAO",
			name: "Đang soạn thảo",
			position: 1,
			show: true,
		},
		{
			value: "KDDH_CHODUYET",
			name: "Chờ duyệt",
			show: false,
			position: 2,
		},
		{
			value: "KDDH_KHONGDUYET",
			name: "Không duyệt",
			show: true,
			position: 3,
		},
		{
			value: "KDDH_CHONVKEHOACH",
			name: "Chờ NV.Kế hoạch xác nhận",
			show: false,
			position: 4,
		},
		{
			value: "KDDH_NVKH_KHONGXACNHAN",
			name: "Không xác nhận",
			show: true,
			position: 5,
		},
		{
			value: "KDDH_DANGTHUCHIEN",
			name: "Đang thực hiện",
			show: true,
			position: 6,
		},
		{
			value: "KDDH_HOANTAT",
			name: "Hoàn tất",
			show: true,
			position: 7,
		},
		{
			value: "KDDH_DAHUY",
			name: "Đã hủy",
			show: true,
			position: 8,
		},
		{
			value: "KDDH_DANGXULYTHFC",
			name: "Đang xử lý - Trang tổng hợp FC",
			show: true,
			position: 11,
		},
	];
	public static readonly STATUS_FORECAST_B2C = [
		{
			value: "KDDH_DANGSOANTHAO",
			name: "Đang soạn thảo",
			position: 1,
			show: true,
		},
		{
			value: "KDDH_CHODUYET",
			name: "Chờ xác nhận",
			show: false,
			position: 2,
		},
		{
			value: "KDDH_KHONGDUYET",
			name: "Không xác nhận",
			show: true,
			position: 3,
		},
		{
			value: "KDDH_CHONVKEHOACH",
			name: "Chờ NV.Kế hoạch xác nhận",
			show: false,
			position: 4,
		},
		{
			value: "KDDH_NVKH_KHONGXACNHAN",
			name: "NV.KH không xác nhận",
			show: true,
			position: 5,
		},
		{
			value: "KDDH_CHOKHHXACNHAN",
			name: "Chờ duyệt",
			show: false,
			position: 4,
		},
		{
			value: "KDDH_TUCHOI",
			name: "Không duyệt",
			show: true,
			position: 5,
		},
		{
			value: "KDDH_DANGTHUCHIEN",
			name: "Đang thực hiện",
			show: true,
			position: 6,
		},
		{
			value: "KDDH_HOANTAT",
			name: "Hoàn tất",
			show: true,
			position: 7,
		},
		{
			value: "KDDH_DAHUY",
			name: "Đã hủy",
			show: true,
			position: 8,
		},
		{
			value: "KDDH_DANGXULYTHFC",
			name: "Đang xử lý - Trang tổng hợp FC",
			show: true,
			position: 11,
		},
	];
	public static readonly STATUS_PURECHASE_ORDER = [
		{
			value: "KDDH_DANGSOANTHAO",
			name: "Đang soạn thảo",
			position: 1,
			show: true,
		},
		{
			value: "KDDH_CHODUYET",
			name: "Chờ duyệt",
			show: true,
			position: 2,
		},
		{
			value: "KDDH_KHONGDUYET",
			name: "Không duyệt",
			show: true,
			position: 3,
		},
		{
			value: "KDDH_CHOKHHXACNHAN",
			name: "Chờ K.Hoạch xác nhận",
			show: true,
			position: 4,
		},
		{
			value: "KDDH_TUCHOI",
			name: "Từ chối",
			show: true,
			position: 5,
		},
		{
			value: "KDDH_CHOCHOTHANG",
			name: "Chờ chốt đơn hàng",
			show: true,
			position: 6,
		},
		{
			value: "KDDH_HUYCHOTHANG",
			name: "Hủy chốt hàng",
			show: false,
			position: 7,
		},
		{
			value: "KDDH_HOANTAT",
			name: "Hoàn tất",
			show: true,
			position: 8,
		},
		{
			value: "KDDH_DAHUY",
			name: "Đã hủy",
			show: true,
			position: 9,
		},
		{
			value: "KDDH_XOA",
			name: "Đã xóa",
			show: false,
			position: 10,
		},
		{
			value: "KDDH_DANGTHUCHIEN",
			name: "Đang thực hiện",
			show: true,
			position: 11,
		},
	];
	public static readonly DROPDOWN_LOAICHIETKHAU = [
		{
			key: "THEOSOTIEN",
			value: "Theo số tiền",
			default: true,
		},
		{
			key: "THEOTYLE",
			value: "Theo tỷ lệ",
			default: false,
		},
	];
	public static readonly WAIT_TO_PLANNING_EMPLOYEE = "KDDH_CHONVKEHOACH";
	public static readonly REMAINING_QUANTITY_COLUMN = [
		{
			stt: 4,
			name: "SLCL",
			displayName: "Số lượng còn lại",
			alwaysChecked: false,
			isShow: true,
		},
	];
	public static readonly EXTEND_FORECAST_COLUMNS = [
		{
			stt: 4,
			name: "SLSDC",
			displayName: "Số lượng sau điều chỉnh",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "SLGN",
			displayName: "Số lượng gần nhất",
			alwaysChecked: false,
			isShow: true,
		},
	];
	public static readonly PROCESSING_FORECAST = {
		code: "KDDH_DANGXULYTHFC",
		value: "Đang xử lý - Trang tổng hợp FC",
		equals: ["KDDH_CHODUYET", "KDDH_CHONVKEHOACH", "KDDH_CHOKHHXACNHAN"],
	};

  public static readonly REMAINING_QUANTITY_COLUMN_DETAIL = {
    position: 8,
    positionExtendDetail: 7,
    columns: {
      stt: 6,
      name: 'SOLUONGCONLAI',
      displayName: 'Số lượng còn lại',
      alwaysChecked: false,
      isShow: true
    }
  }
}
